import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 12/13;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Files" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="files-list" transform="translate(-1234.000000, -163.000000)" fill={color} fillRule="nonzero">
                <g id="Group-34" transform="translate(1230.000000, 158.000000)">
                    <g id="google-drive-logo" transform="translate(4.000000, 5.000000)">
                        <path d="M12.6990746,7.24458204 L8.54628078,0 L4.45369562,0 L8.60648946,7.24458204 L12.6990746,7.24458204 Z M5.11573145,7.84829721 L3.06943887,11.4705882 L10.9536838,11.4705882 L13,7.84829721 L5.11573145,7.84829721 Z M3.91202993,0.905572755 L0,7.84829721 L2.04629258,11.4705882 L6.01850759,4.52786378 L3.91202993,0.905572755 Z" id="Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconGDrive extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
